import React from 'react'
import * as UI from 'ui'
import {
  ForEachModel,
  ValueToCollection,
  WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty, WhenModelValue
} from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Link } from '@morningtrain/react-navigation'
import * as Fields from 'support/fields'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import { Fieldset } from 'layouts'

export default function UserWorkPermitsView () {
  return (
    <UI.CardGroup>

      <UI.Card>
        <UI.CardHeader>
          <UI.SecondaryHeading>
            <Translation name='fields.is_danish_citizen.label' />
          </UI.SecondaryHeading>
          <UpdateModelOnChange name='is_danish_citizen' modify={v => ([false, 0, '0'].includes(v) ? 0 : 1)}>
            <Fields.TabsField
              name='is_danish_citizen'
              enum='boolean_status'
              defaultValue={1}
              label={false}
            />
          </UpdateModelOnChange>
        </UI.CardHeader>

        <Fieldset cols={3}>
          <WhenModelValue name='is_danish_citizen' condition={v => v === 0 || v === false}>
            <Fields.Date
              name='permit_expires_at'
              label={<Translation name='fields.permit_expires_at.label' />}
            />
            <Fields.File
              name='work_permit_files[]'
              multiple
              label={<Translation name='fields.work_permit.label' />}
            />
          </WhenModelValue>
        </Fieldset>
      </UI.Card>

      <UI.Card>
        <UI.CardHeader>
          <UI.SecondaryHeading>
            <Translation name='tabs.work_permits' />
          </UI.SecondaryHeading>
        </UI.CardHeader>
        <ValueToCollection name='work_permit_files'>
          <WhenCollectionIsEmpty>
            <Translation name='partials.no_work_permits' />
          </WhenCollectionIsEmpty>
          <WhenCollectionIsNotEmpty>
            <Table>
              <Columns.Text
                name='name'
                label={<Translation name='columns.name.label' />}
              />
              <Columns.DateTime
                name='updated_at'
                label={<Translation name='columns.updated_at.label' />}
              />
              <Columns.Column>
                <Link route='app.users.work_permit' parameters={{ file: 'model:id' }} disableRouting>
                  <UI.Icons.Download />
                </Link>
              </Columns.Column>
            </Table>
          </WhenCollectionIsNotEmpty>
        </ValueToCollection>
      </UI.Card>
    </UI.CardGroup>
  )
}
